import * as React from "react";
import { Component } from "react";
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Glyphicon,
  HelpBlock,
} from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import DividerLine from "src/components/common/DividerLine";
import { IBaseState } from "src/interfaces";
import { ISimpleDualRateStatementProps } from "./interfaces";

export default class SimpleDualRateStatement extends Component<
  ISimpleDualRateStatementProps,
  IBaseState
> {
  public constructor(props: ISimpleDualRateStatementProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleServiceStartDate = this.handleServiceStartDate.bind(this);
    this.handleServiceEndDate = this.handleServiceEndDate.bind(this);
    this.handleStatementDate = this.handleStatementDate.bind(this);
    this.handleYearsWithSolar = this.handleYearsWithSolar.bind(this);
    this.handleTotalAmountDue = this.handleTotalAmountDue.bind(this);

    this.handleTotalElectricityFromGrid = this.handleTotalElectricityFromGrid.bind(this);
    this.handleOnPeakElectricityFromGrid = this.handleOnPeakElectricityFromGrid.bind(this);
    this.handleTotalElectricityCredited = this.handleTotalElectricityCredited.bind(this);
    this.handleOnPeakElectricityCredited = this.handleOnPeakElectricityCredited.bind(this);
    this.handleLastMonthOnPeakCredit = this.handleLastMonthOnPeakCredit.bind(this);
    this.handleLastMonthOffPeakCredit = this.handleLastMonthOffPeakCredit.bind(this);
    this.handleSolarGenerated = this.handleSolarGenerated.bind(this);
  }
  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 6;
    const smInputWidthR = 6;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    const offPeakElectricityFromGrid =
      this.props.totalElectricityFromGrid - this.props.onPeakElectricityFromGrid;
    const offPeakElectricityCredited =
      this.props.totalElectricityCredited - this.props.onPeakElectricityCredited;
    const netOnPeakElectricity =
      this.props.onPeakElectricityFromGrid -
      this.props.onPeakElectricityCredited -
      this.props.lastMonthOnPeakCredit;
    const netOffPeakElectricity =
      offPeakElectricityFromGrid - offPeakElectricityCredited - this.props.lastMonthOffPeakCredit;
    const netSolarUsage = this.props.solarGenerated - this.props.totalElectricityCredited;
    let onPeakProportional = 0.0;
    if (this.props.totalElectricityCredited) {
      onPeakProportional =
        this.props.onPeakElectricityCredited / this.props.totalElectricityCredited;
      onPeakProportional = onPeakProportional * netSolarUsage;
    }
    let offPeakProportional = 0.0;
    if (this.props.totalElectricityCredited) {
      offPeakProportional = offPeakElectricityCredited / this.props.totalElectricityCredited;
      offPeakProportional = offPeakProportional * netSolarUsage;
    }

    return (
      <div className="flex">
        <div className="left-column">
          <Form horizontal={true}>
            <fieldset className="fieldset-left">
              <legend>Statement Summary</legend>
              <FormGroup bsSize="small" controlId="advstatementDate">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Statement Date
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="date"
                    value={new Date(this.props.statementDate).toISOString().substring(0, 10)}
                    onChange={this.handleStatementDate}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="serviceStartDate">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Service Start
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="date"
                    value={new Date(this.props.serviceStartDate).toISOString().substring(0, 10)}
                    onChange={this.handleServiceStartDate}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="serviceEndDate">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Service End
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="date"
                    value={new Date(this.props.serviceEndDate).toISOString().substring(0, 10)}
                    onChange={this.handleServiceEndDate}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="advyearsWithSolar">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Years with Solar
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.yearsWithSolar}
                    onChange={this.handleYearsWithSolar}
                  />
                  <HelpBlock>(Optional)</HelpBlock>
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="advtotalAmountDue">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Amount Due
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <CurrencyInput
                    className="currency-input form-control input-sm"
                    value={this.props.totalAmountDue}
                    precision={2}
                    prefix={"$"}
                    inputType="text"
                    readOnly={false}
                    onChange={this.handleTotalAmountDue}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-left">
              <legend>Electricity from Grid</legend>
              <FormGroup bsSize="small" controlId="totalElectricityFromGrid">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Total
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.totalElectricityFromGrid}
                    onChange={this.handleTotalElectricityFromGrid}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="onPeakElectricityFromGrid">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  On-peak
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.onPeakElectricityFromGrid}
                    onChange={this.handleOnPeakElectricityFromGrid}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="offPeakElectricityFromGrid">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  Off-peak
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    readOnly={true}
                    tabIndex={-1}
                    value={offPeakElectricityFromGrid}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-left">
              <legend>Electricity Credited</legend>
              <FormGroup bsSize="small" controlId="totalElectricityCredited">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  Total
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.totalElectricityCredited}
                    onChange={this.handleTotalElectricityCredited}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="onPeakElectricityCredited">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  On-Peak
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.onPeakElectricityCredited}
                    onChange={this.handleOnPeakElectricityCredited}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="offPeakElectricityCredited">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  Off-peak
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={offPeakElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xs={xsLabelWidthL}
                sm={smLabelWidthL}
                md={mdLabelWidthL}
                xsOffset={xsInputWidthL}
                smOffset={smInputWidthL}
                mdOffset={mdInputWidthL}
              />
              <FormGroup bsSize="small" controlId="lastMonthOnPeakCredit">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  On-peak Credit
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.lastMonthOnPeakCredit}
                    onChange={this.handleLastMonthOnPeakCredit}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="lastMonthOfFPeakCredit">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                >
                  Off-peak Credit
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.lastMonthOffPeakCredit}
                    onChange={this.handleLastMonthOffPeakCredit}
                  />
                </Col>
              </FormGroup>
            </fieldset>
          </Form>
        </div>
        <div className="right-column">
          <Form horizontal={true}>
            <fieldset className="fieldset-right">
              <legend>Solar Generated</legend>
              <FormGroup bsSize="small" controlId="solarGenerated">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Total Solar Generated
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarGenerated}
                    onChange={this.handleSolarGenerated}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="solarReceived">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Total Received
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.totalElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xs={xsLabelWidthR}
                sm={smLabelWidthR}
                md={mdLabelWidthR}
                xsOffset={xsInputWidthR}
                smOffset={smInputWidthR}
                mdOffset={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="netSolarUsage">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Net Total Solar Used
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={netSolarUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="totalOnPeakSolarReceived">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  On-peak Solar Received
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.onPeakElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="totalOffPeakSolarReceived">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Off-peak Solar Received
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={offPeakElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="onPeakProportional">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Proportional On-peak
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={onPeakProportional.toFixed(3)}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="offPeakProportional">
                <Col
                  xs={xsLabelWidthR}
                  md={mdLabelWidthL}
                  sm={smLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Proportional Off-peak
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={offPeakProportional.toFixed(3)}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-right">
              <legend>Net Electricity</legend>
              <FormGroup bsSize="small" controlId="onPeakElectricitySaved">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  On-peak Used
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.onPeakElectricityFromGrid}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="onPeakElectricityCredited">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  <Glyphicon glyph="glyphicon glyphicon-minus" /> On-peak Credited
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.onPeakElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="lastMonthOnPeakCredit">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  <Glyphicon glyph="glyphicon glyphicon-minus" /> On-Peak Credit
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.lastMonthOnPeakCredit}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xs={xsLabelWidthR}
                sm={smLabelWidthR}
                md={mdLabelWidthR}
                xsOffset={xsInputWidthR}
                smOffset={smInputWidthR}
                mdOffset={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="netOnPeakElectricity">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  Net On-peak
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={netOnPeakElectricity}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="offPeakElectricityUsed">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  Off-peak Used
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={offPeakElectricityFromGrid}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="offPeakElectricityCredited">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  <Glyphicon glyph="glyphicon glyphicon-minus" /> Off-peak Credited
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={offPeakElectricityCredited}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="lastMonthOffPeakCredit">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  <Glyphicon glyph="glyphicon glyphicon-minus" /> Off-peak Credit
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.lastMonthOffPeakCredit}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xs={xsLabelWidthR}
                sm={smLabelWidthR}
                md={mdLabelWidthR}
                xsOffset={xsInputWidthR}
                smOffset={smInputWidthR}
                mdOffset={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="netOffPeakElectricity">
                <Col
                  componentClass={ControlLabel}
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                >
                  Net Off-peak
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={netOffPeakElectricity}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
            </fieldset>
          </Form>
        </div>
      </div>
    );
  }

  private handleTotalAmountDue(e: any, floatValue: number, formattedValue: string) {
    this.props.handleTotalAmountDue(floatValue);
  }
  private handleTotalElectricityFromGrid(e: any) {
    this.props.handleTotalElectricityFromGrid(e.target.value);
  }
  private handleOnPeakElectricityFromGrid(e: any) {
    this.props.handleOnPeakElectricityFromGrid(e.target.value);
  }
  private handleTotalElectricityCredited(e: any) {
    this.props.handleTotalElectricityCredited(e.target.value);
  }
  private handleOnPeakElectricityCredited(e: any) {
    this.props.handleOnPeakElectricityCredited(e.target.value);
  }
  private handleLastMonthOnPeakCredit(e: any) {
    this.props.handleLastMonthOnPeakCredit(e.target.value);
  }
  private handleLastMonthOffPeakCredit(e: any) {
    this.props.handleLastMonthOffPeakCredit(e.target.value);
  }
  private handleStatementDate(e: any) {
    this.props.handleStatementDate(e.target.value);
  }
  private handleServiceStartDate(e: any) {
    this.props.handleServiceStartDate(e.target.value);
  }
  private handleServiceEndDate(e: any) {
    this.props.handleServiceEndDate(e.target.value);
  }
  private handleYearsWithSolar(e: any) {
    this.props.handleYearsWithSolar(e.target.value);
  }
  private handleSolarGenerated(e: any) {
    this.props.handleSolarGenerated(e.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/simple/dualrate/SimpleDualRateStatement.tsx